import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_DELETE_SHOWING } from 'api/actionTypes';

export default async function deleteShowing(
  { state, apiClient },
  { tourId, listingId, tourCancelReason, onSuccess },
) {
  typeCheck('onSuccess::Maybe Function', onSuccess);
  await apiClient.postWithState({
    action: SR_API_ACTION_DELETE_SHOWING,
    queryId: `${tourId}-${listingId}`,
    state: state,
    payload: {
      tourId,
      listingId,
      tourCancelReason,
    },
    onSuccess(tours) {
      state.set(['tours'], tours);
      state.commit();
      if (onSuccess) {
        onSuccess();
      }
    },
  });
}
